import { POIDoorFeature } from '../features/poi-door/poi-door.feature';
import { StandardLayerRenderer } from './standard-layer.renderer';

export class POIDoorsLayerRenderer extends StandardLayerRenderer {
  protected Feature = POIDoorFeature;
}
